import LinkIcon from '@material-ui/icons/Link';
import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';

const rootRouteRef = createRouteRef();

const serviceDirectoryPage = PageBlueprint.make({
  params: {
    path: '/service-directory',
    title: 'Service & URL Directory',
    icon: <LinkIcon />,
    routeRef: rootRouteRef,
    loader: () =>
      import('./ServiceDirectoryPage').then(module => (
        <module.ServiceDirectoryPage />
      )),
  },
});

export const serviceDirectoryPlugin = createFrontendPlugin({
  pluginId: 'service-directory',
  title: 'Service & URL Directory',
  icon: <LinkIcon />,
  routes: { root: rootRouteRef },
  extensions: [serviceDirectoryPage],
});
